import React from "react";

export default function ScheduleSection() {
  const scheduleItems = [
    {
      title: "Neetsupport.com Introduction",
      description:
        "Get introduced to Neetsupport.com, our platform, and how this seminar will guide you through NEET counselling and admission planning.",
    },
    {
      title: "NEET Preparation Strategy (Last 1 Month)",
      description:
        "Learn effective last-month strategies to improve revision, boost confidence, and maximize your NEET score.",
    },
    {
      title: "Counselling & Admission Process",
      description:
        "Understand MCC and state counselling, rounds, documentation, and the complete step-by-step admission process.",
    },
    {
      title: "Government Medical College Strategy",
      description:
        "Discover practical ways to target government medical colleges even with a lower NEET score.",
    },
    {
      title: "Low Fees Medical College Options",
      description:
        "Explore affordable medical colleges and learn how to select the best options based on your budget and rank.",
    },
    {
      title: "Detailed College Overview",
      description:
        "Compare colleges based on cutoffs, fees, facilities, and career opportunities to make informed decisions.",
    },
    {
      title: "Useful Tools for NEET Counselling",
      description:
        "Get access to tools and resources that simplify college prediction, choice filling, and decision making.",
    },
    {
      title: "How We Support Your Admission",
      description:
        "Understand how our team guides you through counselling, documentation, and securing your seat.",
    },
    {
      title: "Live Q&A Session",
      description:
        "Ask your doubts directly and get personalized guidance for your counselling and admission journey.",
    },
  ];

  return (
    <section className="relative overflow-hidden py-8 sm:py-10 lg:py-12">
      <div className="relative mx-auto max-w-6xl px-4 sm:px-5 lg:px-6">
        <div className="mx-auto text-center">
          <h2
            className="text-center text-2xl font-bold capitalize sm:text-3xl"
            style={{ color: "#0F172A" }}
          >
            What You’ll <span className="text-[#ff9245]">Learn</span>
          </h2>

          <p className="mx-auto mt-3 w-full text-sm text-slate-600 sm:text-lg">
            Understand counselling, college selection, and admission planning
            with clarity and confidence.
          </p>
        </div>

        <div className="relative mx-auto mt-8 max-w-6xl">
          <div className="absolute left-4 top-0 h-full w-[2px] bg-[#ffd8bf] sm:left-1/2 sm:-translate-x-1/2" />

          <div className="space-y-5">
            {scheduleItems.map((item, index) => {
              const isLeft = index % 2 === 0;

              return (
                <div
                  key={index}
                  className="relative grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-8"
                >
                  <div
                    className={`pl-8 sm:pl-0 ${
                      isLeft ? "sm:pr-8" : "sm:order-2 sm:pl-8"
                    }`}
                  >
                    <div
                      className={`relative rounded-[16px] border border-[#f3e3d8] bg-white p-4 shadow-sm transition duration-300 hover:-translate-y-0.5 hover:shadow-md sm:p-5 ${
                        isLeft ? "" : "sm:mt-6"
                      }`}
                    >
                      <h3 className="text-sm font-bold leading-5 text-[#0F172A] sm:text-base">
                        {item.title}
                      </h3>

                      <p className="mt-2 text-sm leading-6 text-slate-600">
                        {item.description}
                      </p>

                      <div
                        className={`absolute top-5 hidden h-[2px] w-6 bg-[#ffd8bf] sm:block ${
                          isLeft ? "-right-6" : "-left-6"
                        }`}
                      />
                    </div>
                  </div>

                  <div className={`${isLeft ? "sm:order-2" : "sm:order-1"}`} />

                  <div className="absolute left-4 top-5 z-10 h-3 w-3 -translate-x-1/2 rounded-full border-[2px] border-[#fffaf6] bg-[#ff9245] sm:left-1/2" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}